import { useContext } from "react";
import { GameContext } from "../context/GameContext";

export default function GuessedWordsRecipient() {
  const { guessedWords } = useContext(GameContext);

  return (
    <>
      <h1 className="mt-2 mb-1 font-bold text-white">Words formed:</h1>

      <aside className="guessedWordsRecipient shadow-cyan-500/50 rounded-lg shadow-md border-2 border-cyan-500 animate__bounceIn bg-white p-2">
        <div className="flex flex-wrap gap-1.5">
          {guessedWords.map((word, index) => (
            <figure
              key={index}
              className="guessedWord h-9 flex items-center p-1 reverse-gradients"
            >
              <span className="text-white">{word}</span>
            </figure>
          ))}
        </div>
      </aside>
    </>
  );
}
